/* Numerkowo Theme — Main JS */

document.addEventListener('DOMContentLoaded', function() {

  /* Mobile nav close on escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var nav = document.getElementById('mobile-nav');
      if (nav) nav.classList.remove('is-open');
    }
  });

  /* Sticky header shadow on scroll */
  var header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 16px rgba(0,0,0,.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* Smooth scroll for anchor links */
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
